<template>
    <div>
        <ValidationObserver ref="formModalValidate">
           <b-row>
                <b-col cols="12">
                   <ValidationProvider name="user_id" rules="required" v-slot="{valid, errors}">
                       <b-form-group :label="$t('members')">
                           <students-auto-complete
                               :value="selectedPresident"
                               :in-all-students="true"
                               @user-input="handleSelection"
                               :validate-error="errors[0]"></students-auto-complete>
                       </b-form-group>
                   </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="status" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox v-model="form.status" code="	student_club_president_application_user_statuses" :validate-error="errors[0]"></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-button
                    @click="createForm"
                    type="button"
                    :disabled="formLoading"
                    variant="primary"
                    class="btn-lg mr-2"
                >
                    {{ $t("save") | toUpperCase }}
                </b-button>
           </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import StudentClubService from "@/services/StudentClubService";
    import StudentsAutoComplete from "@/components/interactive-fields/StudentsAutoComplete.vue";

    export default {
        components: {
            StudentsAutoComplete,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                formLoading: false,
                selectedPresident: '',
                form: {
                    student_club_president_application_id: this.formId,
                    user_id: null,
                    status: null
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;
                    StudentClubService.storePresidentUsers(this.form)
                                    .then((response) => {
                                        this.$toast.success(this.$t("api." + response.data.message));
                                        this.$emit("createFormSuccess")
                                    })
                                    .catch((error) => {
                                        this.showErrors(error, this.$refs.formModalValidate)
                                    }).finally(() => {
                        this.formLoading = false;
                    });
                }
            },
            handleSelection(user) {
                this.form.user_id = user?.user_id;
                this.selectedPresident = user ? `${user.name} ${user.surname}` : '';
            }
        }
    }
</script>
